import { LocalDate } from 'js-joda';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessClosedDay } = protos;

export function fetch(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/closed-days',
      type: AppConstants.BUSINESS_CLOSED_DAYS_FETCH,
    },
  };
}

export function save(date: LocalDate, reason?: string): ApiAction {
  return {
    TockApi: {
      postProto: '/business/closed-days',
      request: BusinessClosedDay.fromObject({ date, reason: reason || undefined }),
      type: AppConstants.BUSINESS_CLOSED_DAYS_ADD,
      toast: 'Closed Day Added',
    },
  };
}

export function remove(id: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/business/closed-days/${id}`,
      type: AppConstants.BUSINESS_CLOSED_DAYS_DELETE,
      toast: 'Closed Day Removed',
      context: { id },
    },
  };
}
